import { FC, useState } from "react"
import { UserCheck } from "lucide-react";

interface TenantGuarantorTooltipProps {
  fullName: string
  professionnalSituation: string
}

export const TenantGuarantorTooltip: FC<TenantGuarantorTooltipProps> = ({
  fullName,
  professionnalSituation
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        className={`flex items-center justify-center rounded hover:bg-gray-100 transition-colors`}
      >
        <UserCheck className="text-primary" size={16} />
      </button>

      {showTooltip && (
        <div className="absolute z-10 left-1/2 -translate-x-1/2 mt-2 w-64 bg-white border border-gray-200 text-slate-500 text-sm rounded-lg shadow-lg p-3">
          <div className="font-semibold mb-2 border-b text-primary border-primary pb-2">
            Garant
          </div>
          <div className="space-y-1.5">
            <div><span className="text-primary">Nom:</span> {fullName}</div>
            <div><span className="text-primary">Situation professionnelle:</span> {professionnalSituation}</div>
          </div>
          <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 border-t border-l border-gray-200 bg-zinc-50 rotate-45"></div>
        </div>
      )}
    </div>
  );
};
